import { useState } from 'react'
import { useConfiguracionEstudio } from '@/hooks/useConfiguracion'
import { exigirConfiguracionEstudio } from '@/services/configuracionService'
import { useOrganizacion } from '@/core/providers/OrganizacionProvider'
import { renderEstadoCuentaPDF, type DatosEstadoCuentaSinEstudio } from '@/lib/estadoCuentaBase64'

export function useDescargarEstadoCuentaPDF() {
  const { data: configData, isError: configError } = useConfiguracionEstudio()
  const { organizacion } = useOrganizacion()
  const [generando, setGenerando] = useState(false)

  const descargar = async (datos: DatosEstadoCuentaSinEstudio, filename?: string) => {
    setGenerando(true)
    try {
      const config = exigirConfiguracionEstudio({ data: configData, isError: configError })

      const logoUrl = organizacion?.branding?.logo_light_url || organizacion?.branding?.logo_dark_url || undefined

      const blob = await renderEstadoCuentaPDF(datos, config, logoUrl)

      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename ?? `estado-cuenta-${new Date().toISOString().split('T')[0]}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } finally {
      setGenerando(false)
    }
  }

  return { descargar, generando }
}
